export type ILessonListType = {
  name: string;
  items: ILessonItemType[];
  nextEducationPackID?: number;
  previousEducationPackID?: number;
};
export type ILessonType = {
  packItemName?: string;
  packItemTypeName?: string;
  hasAccess: boolean;
  educationPackItemName: string;
  lastTakingId: number;
  description?: string;
  duration: number;
  tryCnt: number;
  hasFinished: boolean;
  packItemTypeID?: number;
  inCorrectAnswerCnt?: number;
  correctAnswerCnt?: number;
  completenessPercent?: number;
  spentDuration: number;
  maxScore?: number;
  score?: number;
  mark?: number;
  noAnswerCnt?: number;
  questionCount?: number;
  hasExpired?: boolean;
  data?: string;
  free: boolean;
  educationPackID?: number;
  educationPackItemID?: number;
  status: number;
  packItemIndex: number;
  rn: number;
  selfExam?: boolean;
  hasPrintAccess: boolean;
  refrenceID: number;
  seriId: number;
};
export type ILessonItemType = {
  id: number;
  levelIndex: number;
  name: string;
  totalEducationPackCount: number;
  steps: ILessonType[];
};
export enum packItemTypeIDEnum {
  PRACTICE = 1,
  LECTURE = 2,
  EXAM = 3,
  VIDEO = 4,
  VOICE = 5,
  PDF = 6,
  DESCRIPTIVE_PRACTICE = 7,
  PRACTICE_EXAM = 8,
}
export enum examAndPracticeStatusEnum {
  START = 1,
  CONTINUE = 2,
  RESTART = 3,
}

export enum EnumPrintTemplate {
  FINAL_EXAM_EXPLEMENTARY = 10,
  CLASSIC_EXAM = 20,
}
